export default __webpack_public_path__ + "static/media/320x180.51d00cad.jpg";